import classNames from 'classnames';
import Avatar from 'components/base/Avatar';
import React from 'react';
import { Col, Nav } from 'react-bootstrap';
import { Props } from './candidateList.type';
import avatar from 'assets/img/profile/profileImage.jpg';
import { CandidateProfile } from '../candidateOverview.type';

function CandidateList({ data, setSelectedData, selectedItem }: Props) {
  const handleSelect = (item: CandidateProfile) => {
    setSelectedData(item);
  };
  return (
    <Col md={6} xl={5} xxl={4}>
      <Nav
        className="faq-subcategory-tab scrollbar align-content-start w-sm-75 w-md-100 mx-auto mb-4 gap-3"
        style={{ width: '90%' }}
      >
        {Array.isArray(data) &&
          data.map((item, idx) => {
            const {
              _id,
              username,
              info: { about, profileImage }
            } = item;
            return (
              <Nav.Item className="w-100" key={idx}>
                <Nav.Link
                  className={classNames(
                    'd-flex align-items-center justify-content-center p-2',
                    {
                      unread: false,
                      active: selectedItem ? selectedItem === _id : idx === 0
                    }
                  )}
                  onClick={e => {
                    e.preventDefault();
                    handleSelect(item);
                  }}
                >
                  <div className="position-relative me-2 me-sm-0 me-xl-2">
                    <Avatar
                      src={profileImage || avatar}
                      size="xl"
                      className="d-block"
                      imageClassName="border border-2 border-light-subtle"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="text-body fw-normal name text-nowrap">
                        {username}
                      </h5>
                      <p className="fs-10 text-body-tertiary text-opacity-85 mb-0 text-nowrap">
                        Candidate
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="fs-9 mb-0 line-clamp-1 text-body-tertiary text-opacity-85 message">
                        {about}
                      </p>
                    </div>
                  </div>
                </Nav.Link>
              </Nav.Item>
            );
          })}
      </Nav>
    </Col>
  );
}

export default CandidateList;
